import { useState } from "react";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "Exchanges and Refunds",
    a: "Every piece is one of one — once it's sold, it's gone for good. We don't accept returns or exchanges unless the item arrives different from what was described. Reach out via Instagram DM within 24 hours of delivery if there's an issue.",
  },
  {
    q: "Sizes",
    a: "All sizing is listed on each product page based on how the piece actually fits, not the tag size. Vintage runs differently than modern clothing — DM us if you want exact measurements before buying.",
  },
  {
    q: "Delivery",
    a: "We ship via Turbo, 3–5 working days across Egypt. Pickup is also available in Zamalek, Cairo if you're local — just let us know at checkout.",
  },
  {
    q: "Condition of Pieces",
    a: "Everything is genuine vintage and thrifted, so expect some natural wear — that's part of the charm. Condition notes are listed on each product page; if anything's flawed beyond normal vintage wear, we'll always say so.",
  },
];

export function FaqSection() {
  const [open, setOpen] = useState<number | null>(null);
  const marqueeText = Array.from({ length: 6 }, () => "PLEASE READ OUR FAQ FOR ANY QUESTIONS").join("   ✦   ");

  return (
    <section className="w-full bg-foreground text-background">
      {/* Marquee strip */}
      <div className="overflow-hidden border-b border-background/20 py-4">
        <div
          className="flex w-max gap-0 whitespace-nowrap text-3xl uppercase tracking-tight sm:text-5xl"
          style={{ animation: "marquee 22s linear infinite" }}
        >
          <span className="pr-4">{marqueeText}</span>
          <span className="pr-4">{marqueeText}</span>
        </div>
      </div>

      <div className="mx-auto max-w-2xl px-4 py-16 sm:px-6 sm:py-24">
        <h2 className="mb-10 text-center text-2xl uppercase tracking-[-0.01em] sm:text-3xl">FAQs</h2>

        <div className="w-full">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="border border-background/30 mb-3 px-5 last:mb-0">
                <button
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="flex w-full items-center justify-center gap-2 py-4 text-center text-[12px] uppercase tracking-[0.15em]"
                >
                  {f.q}
                  <ChevronDown
                    className={`h-4 w-4 shrink-0 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
                  />
                </button>
                <div
                  className="overflow-hidden transition-[grid-template-rows] duration-300 ease-out grid"
                  style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
                >
                  <div className="min-h-0 overflow-hidden">
                    <p className="pb-5 text-center text-xs leading-relaxed text-background/70">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
